import React, { useMemo } from 'react';
import { Calculator } from 'lucide-react';
import { useProperties } from '../hooks/useProperties';
import { PropertyCategoryView } from '../components/properties/PropertyCategoryView';
import { Counter } from '../components/ui/Counter';

export const EstimationsList: React.FC = () => {
  const { properties, isLoading } = useProperties();

  const estimations = useMemo(
    () => properties.filter(p => p.status === 'estimation'),
    [properties]
  );

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-4">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <Calculator className="h-8 w-8 text-primary-500" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Estimations
              </h1>
            </div>
            <Counter 
              count={estimations.length} 
              label={estimations.length > 1 ? "estimations" : "estimation"}
              variant="warning"
            />
          </div>
        </div>
        <PropertyCategoryView
          title=""
          properties={estimations}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};